export const RESOURCE_ASSETS_NAVIGATION_SETTINGS = 'RESOURCE_ASSETS_NAVIGATION_SETTINGS';
export const RESOURCE_ASSETS_NAVIGATION_SETTINGS_KEY = 'settings';

export const NAVIGATION_SETTINGS_KEYS = {
	BG_COLOR: 'assets.navigation.bgcolour',
	HIGHLIGHT_COLOR: 'assets.navigation.highlightcolour',
} as const;

export const RESOURCE_TYPE_WORKSPACE_CONTEXT = 'JSM_INSIGHT_WORKSPACE_CONTEXT';

// Cache duration for assets admin settings (15 minutes)
export const ASSETS_ADMIN_SETTINGS_MAX_AGE = 15 * 60 * 1000;
